/**
 * Ready to Ride Bundle Promo - Brooklyn Bicycle Co.
 * Auto-adds Commuter Bundle Plus + applies READYRIDE discount
 * for visitors arriving on a PDP from the Ready to Ride LP or email.
 *
 * Mirrors the architecture of lp-bundle-promo.js / spring-bundle-promo.js.
 * Independent constants so it cannot collide with either existing campaign.
 *
 * Eligible bikes: roebling, lorimer, bedford-8, wythe
 * Bundle variant: 40217649610832 (Commuter Bundle Plus, $114.99, made $0 by the READYRIDE BXGY discount)
 */
(function () {
  'use strict';

  var SESSION_KEY = 'bbc_readytoride';
  var PROMO_KEY = 'rtr_bundle_promo';
  var PROMO_VALUE = 'ready-to-ride';
  var BUNDLE_VARIANT = 40217649610832;
  var DISCOUNT_CODE = 'READYRIDE';
  var BIKE_HANDLES = ['roebling', 'lorimer', 'bedford-8', 'wythe'];

  function isOnRTRPage() {
    var p = window.location.pathname;
    return (
      p.indexOf('/pages/ready-to-ride') === 0 ||
      p.indexOf('/collections/ready-to-ride') === 0
    );
  }

  function isOnPDP() {
    var p = window.location.pathname;
    for (var i = 0; i < BIKE_HANDLES.length; i++) {
      if (p.indexOf('/products/' + BIKE_HANDLES[i]) === 0) return true;
    }
    return false;
  }

  function isOnCart() {
    return window.location.pathname === '/cart';
  }

  function stashSession() {
    try { sessionStorage.setItem(SESSION_KEY, 'true'); } catch (e) {}
  }

  function stashPromo() {
    try { sessionStorage.setItem(PROMO_KEY, PROMO_VALUE); } catch (e) {}
  }

  function hasSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === 'true' ||
             sessionStorage.getItem(PROMO_KEY) === PROMO_VALUE;
    } catch (e) {}
    return false;
  }

  function clearPromo() {
    try { sessionStorage.removeItem(PROMO_KEY); } catch (e) {}
  }

  function addBundleApplyDiscountAndOpenDrawer(bikeProduct) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBundle = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === BUNDLE_VARIANT) hasBundle = true;
        }
        if (hasBundle) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: BUNDLE_VARIANT, quantity: 1 }] })
        })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: DISCOUNT_CODE })
          });
        })
        .then(function () {
          clearPromo();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
        });
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
      });
  }

  window.__readyToRideBundlePromo = {
    hasSession: hasSession,
    addBundleApplyDiscountAndOpenDrawer: addBundleApplyDiscountAndOpenDrawer
  };

  function tagRTRLinks() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('promo=' + PROMO_VALUE) !== -1) continue;
      var isBike = false;
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (href.indexOf('/products/' + BIKE_HANDLES[b]) !== -1) { isBike = true; break; }
      }
      if (!isBike) continue;
      links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'promo=' + PROMO_VALUE);
    }
  }

  function pdpInit() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('promo') === PROMO_VALUE) {
      stashPromo();
    }
    if (hasSession()) {
      interceptATC();
    }
  }

  function interceptATC() {
    var origFetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasSession()) {
        return origFetch.apply(this, arguments);
      }

      var body = opts.body;
      if (body && typeof body === 'string' && body.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origFetch.apply(this, arguments);
      }

      return origFetch.apply(this, arguments).then(function (response) {
        var cloned = response.clone();
        cloned.json().then(function (bikeProduct) {
          addBundleApplyDiscountAndOpenDrawer(bikeProduct);
        }).catch(function () {
          addBundleApplyDiscountAndOpenDrawer(null);
        });
        return response;
      });
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._rtrUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (data) {
      var xhr = this;
      var url = xhr._rtrUrl || '';
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasSession()) {
        return origSend.apply(this, arguments);
      }
      if (data && typeof data === 'string' && data.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origSend.apply(this, arguments);
      }

      var origOnLoad = xhr.onload;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var bikeProduct = JSON.parse(xhr.responseText);
            addBundleApplyDiscountAndOpenDrawer(bikeProduct);
          } catch (e) {
            addBundleApplyDiscountAndOpenDrawer(null);
          }
        }
        if (origOnLoad) origOnLoad.apply(xhr, arguments);
      };

      return origSend.apply(this, arguments);
    };
  }

  function cartGuard() {
    function checkAndClean() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasBike = false;
          var bundleQty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            for (var b = 0; b < BIKE_HANDLES.length; b++) {
              if (item.handle === BIKE_HANDLES[b]) { hasBike = true; break; }
            }
            if (item.variant_id === BUNDLE_VARIANT || item.id === BUNDLE_VARIANT) {
              bundleQty = item.quantity;
            }
          }
          if (bundleQty > 0 && !hasBike) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 0 })
            }).then(function () { window.location.reload(); });
          } else if (bundleQty > 1) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 1 })
            }).then(function () { window.location.reload(); });
          }
        }).catch(function () {});
    }

    setTimeout(checkAndClean, 800);

    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var isCartMod = (typeof url === 'string' &&
        (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1));
      var result = origFetch.apply(this, arguments);
      if (isCartMod) {
        result.then(function (r) { setTimeout(checkAndClean, 600); return r; });
      }
      return result;
    };
  }

  var BUNDLE_NOTE_CLASS = 'rtr-bundle-free-note';
  var BUNDLE_NOTE_STYLE = 'display:block;font-size:11px;color:#2c3c4c;font-weight:600;' +
    'margin-top:4px;padding:3px 8px;background:#f0ebe4;border-radius:3px;' +
    'line-height:1.3;letter-spacing:0.2px;';

  function getBikeNameFromDrawer() {
    var items = document.querySelectorAll('[data-products] .cart__item-name');
    for (var i = 0; i < items.length; i++) {
      var text = (items[i].textContent || '').toLowerCase();
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (text.indexOf(BIKE_HANDLES[b]) !== -1) {
          return BIKE_HANDLES[b].split('-').map(function (w) {
            return w.charAt(0).toUpperCase() + w.slice(1);
          }).join(' ');
        }
      }
    }
    return '';
  }

  /* BBC 2026-09-11: only show the "Included FREE" note when the bundle line is
     actually $0 in the drawer (i.e. the discount really applied). */
  function bundleLineIsFree(titleEl) {
    var row = titleEl.closest('.cart__item');
    if (!row) return false;
    var priceEls = row.querySelectorAll('.cart__item-price-col .cart__price');
    var priceEl = null;
    for (var p = 0; p < priceEls.length; p++) {
      if (priceEls[p].className.indexOf('strikethrough') === -1) priceEl = priceEls[p];
    }
    if (!priceEl) return false;
    var digits = (priceEl.textContent || '').replace(/[^0-9]/g, '');
    return digits.length > 0 && parseInt(digits, 10) === 0;
  }

  /* BBC 2026-09-11: this script now owns the drawer note for the free Commuter
     Bundle Plus (spring-bundle-promo.js, the previous owner, was removed).
     Idempotent on purpose: it only touches the DOM when the note is missing or
     should not be there. The old remove-then-re-add on every mutation made the
     drawer MutationObservers (this one and lp-bundle-promo.js) retrigger each
     other in a loop. */
  function injectBundleNote() {
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var bundleTitleEl = null;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle plus') !== -1) {
        bundleTitleEl = nameLinks[i];
        break;
      }
    }
    var titleWrap = bundleTitleEl ? bundleTitleEl.closest('.cart__item-title') : null;
    var bikeName = titleWrap ? getBikeNameFromDrawer() : '';
    var show = !!(titleWrap && bikeName && bundleLineIsFree(bundleTitleEl));

    if (!show) {
      var mine = document.querySelectorAll('.' + BUNDLE_NOTE_CLASS);
      for (var e = 0; e < mine.length; e++) mine[e].parentNode.removeChild(mine[e]);
      return;
    }

    if (!titleWrap.querySelector('.lp-bundle-free-note, .spring-bundle-free-note, .' + BUNDLE_NOTE_CLASS)) {
      var note = document.createElement('span');
      note.className = BUNDLE_NOTE_CLASS;
      note.setAttribute('style', BUNDLE_NOTE_STYLE);
      note.textContent = 'Included FREE with your ' + bikeName;
      titleWrap.appendChild(note);
    }

    var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container, [class*="upsell"]');
    for (var u = 0; u < upsellCards.length; u++) {
      upsellCards[u].style.display = 'none';
    }
  }

  function restoreUpsellIfNeeded() {
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var hasBundle = false;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle plus') !== -1) { hasBundle = true; break; }
    }
    if (!hasBundle) {
      var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container');
      for (var u = 0; u < upsellCards.length; u++) {
        upsellCards[u].style.display = '';
      }
    }
  }

  function observeBundleNote() {
    var productsEl = document.querySelector('[data-products]');
    if (productsEl && !productsEl.__rtrBundleNoteObs) {
      productsEl.__rtrBundleNoteObs = true;
      new MutationObserver(function () {
        setTimeout(function () { injectBundleNote(); restoreUpsellIfNeeded(); }, 50);
      }).observe(productsEl, { childList: true, subtree: true });
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !drawer.__rtrBundleDrawerObs) {
      drawer.__rtrBundleDrawerObs = true;
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          if (mutations[m].attributeName === 'class') {
            setTimeout(injectBundleNote, 100);
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(injectBundleNote, 300);
    });
    setTimeout(injectBundleNote, 500);
  }

  function init() {
    if (isOnRTRPage()) {
      stashSession();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tagRTRLinks);
      } else {
        tagRTRLinks();
      }
      new MutationObserver(function () { tagRTRLinks(); })
        .observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
    if (isOnPDP()) {
      pdpInit();
    }
    if (isOnCart()) {
      cartGuard();
    }
    // 2026-09-11: spring-bundle-promo.js (previous owner of the drawer note) was
    // removed, so the note for the free Commuter Bundle Plus runs here again.
    // injectBundleNote() is idempotent, so it cannot loop against lp-bundle-promo.js.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeBundleNote);
    } else {
      observeBundleNote();
    }
  }

  init();
})();
